module.exports = __webpack_public_path__ + "media/images/fr/upload-dashboard-03bfb6507aeb9c14feea9e623153e1e2.png";